/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { ClientType, UserRole } from "./public";
import { useUsersApi } from "./setup";
import { ApiError } from "./shared";

export interface Client {
  clientId: string;
  clientLoginProviderEnabled: boolean;
  clientName: string;
  clientRole: UserRole;
  clientType: ClientType;
  deleteRequested: boolean;
  deleted: boolean;
  expired: boolean;
  userId: string;
}

export const useGetClientsQuery = ({ manual = false } = {}) => {
  return useUsersApi<Client[], ApiError>(
    {
      url: formatUrl(api.clients.all),
    },
    {
      manual,
    }
  );
};

export const useCreateClientSelectLog = () => {
  return useUsersApi(
    {
      url: formatUrl(api.log.clientSelect),
      method: "POST",
    },
    {
      manual: true,
    }
  );
};
